import { getOrThrow } from '@espoon-voltti/nuora-app-common/services/error'
import { Type } from 'io-ts'

export const apiBaseUrl = '/api'
export const grantsApiUrl = `${apiBaseUrl}/grants/youth/v1`

export const extractResponseData = ({ data: { data } }: any) => data

declare module 'io-ts' {
  interface Type<A, O = A, I = unknown> {
    decodeOrThrow(x: I): A
  }
}

Type.prototype.decodeOrThrow = function <I>(x: I) {
  const decodedInput = this.decode(x)
  return getOrThrow(decodedInput)
}
